import { useState } from "react";
import { ArrowUp, Globe, Square } from "lucide-react";

interface SimpleChatInputProps {
  onSend: (message: string, useInternet: boolean) => void;
  placeholder?: string;
  isGenerating?: boolean;
}

const SimpleChatInput = ({ onSend, placeholder = "Update this by adding something else", isGenerating = false }: SimpleChatInputProps) => {
  const [message, setMessage] = useState("");
  const [useInternet, setUseInternet] = useState(false);

  const handleSend = () => {
    if (message.trim()) {
      onSend(message, useInternet);
      setMessage("");
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div className="w-full max-w-[751px] mx-auto">
      {/* Container with ChatGPT-inspired styling */}
      <div
        className="flex flex-col justify-between"
        style={{
          backgroundColor: '#f4f4f4',
          borderRadius: '16px',
          border: '1px solid rgba(0,0,0,0.1)',
          padding: '12px'
        }}
      >
        {/* Textarea */}
        <textarea
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyDown={handleKeyPress}
          placeholder={placeholder}
          className="w-full bg-transparent border-none outline-none resize-none min-h-[24px] max-h-[120px] mb-2"
          style={{
            fontSize: '15px',
            fontWeight: 400,
            color: '#000000',
            lineHeight: '1.5'
          }}
          rows={1}
        />

        {/* Bottom Controls Row */}
        <div className="flex items-center justify-end" style={{ gap: '8px' }}>
          {/* Left - Toggle with Label */}
          {/* <div 
            className="flex items-center"
            style={{
              gap: '4px',
              padding: '6px 8px',
              border: '1px solid rgba(0,0,0,0.05)',
              borderRadius: '50px'
            }}
          >
            <button
              onClick={() => setUseInternet(!useInternet)}
              className="relative transition-colors"
              style={{
                width: '21.6px',
                height: '12px',
                borderRadius: '6px',
                backgroundColor: useInternet ? '#000000' : '#e5e5e5'
              }}
            >
              <div
                className="absolute top-1/2 transform -translate-y-1/2 bg-white transition-all"
                style={{
                  width: '8px',
                  height: '8px',
                  borderRadius: '4.8px',
                  left: useInternet ? 'calc(100% - 10px)' : '2px',
                  boxShadow: '0px 1px 2px rgba(0,0,0,0.2)'
                }}
              />
            </button>
            
            <Globe 
              style={{
                width: '16px',
                height: '16px',
                color: '#666666',
                strokeWidth: '1.2px'
              }}
            />
            
            <span
              style={{
                fontSize: '12px',
                fontWeight: 500,
                color: '#000000'
              }}
            >
              Use the web for sources
            </span>
          </div> */}

          {/* Right - Upload Button */}
          <button
            onClick={handleSend}
            disabled={!message.trim() || isGenerating}
            className="flex items-center justify-center transition-opacity hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed"
            style={{
              width: '30px',
              height: '30px',
              borderRadius: '38px',
              backgroundColor: '#000000'
            }}
          >
            {isGenerating ? (
              <Square
                style={{
                  width: '14px',
                  height: '14px',
                  color: '#ffffff',
                  fill: '#ffffff'
                }}
              />
            ) : (
              <ArrowUp
                style={{
                  width: '20px',
                  height: '20px',
                  color: '#ffffff',
                  strokeWidth: '1.67px'
                }}
              />
            )}
          </button>
        </div>
      </div>

      {/* Style tag for placeholder color */}
      <style>{`
        textarea::placeholder {
          font-size: 15px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.2);
        }
      `}</style>
    </div>
  );
};

export default SimpleChatInput;
